import { useEffect, useState } from 'react'

import { Typography, Link, Box } from '@mui/material'

import { useProject } from '../../api/project'
import { useSignup } from '../../context/signup'
import { useProjectId } from '../../hooks/useProjectId'
import { HtmlConnected as Html } from '../html'

export const EndPage = () => {
  const { data: project } = useProject(useProjectId())
  const { user } = useSignup()
  const [countdown, setCountdown] = useState(3)
  const [shouldRedirect, setShouldRedirect] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0)

    if (project?.formRedirectUrl) {
      setShouldRedirect(true)
    }
  }, [])

  useEffect(() => {
    if (shouldRedirect) {
      const timer = setInterval(() => {
        setCountdown((prevCountdown) => {
          if (prevCountdown <= 1) {
            clearInterval(timer)
            window.location.href = project.formRedirectUrl
            return 0
          }
          return prevCountdown - 1
        })
      }, 1000)

      return () => clearInterval(timer)
    }
  }, [shouldRedirect, project])

  if (shouldRedirect) {
    return (
      <Box>
        <Typography>
          Skickar dig vidare om {countdown} sekunder, eller{' '}
          <Link href={project?.formRedirectUrl}>
            klicka här för att fortsätta
          </Link>
          .
        </Typography>
      </Box>
    )
  }

  return <Html name="signup-complete" data={user} />
}
